/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type {
  ConversationTurn,
  CurrencyCode,
  FreightClaimPaymentSource,
  FreightClaimReadModel,
  FreightClaimState,
} from "../models/index";
import {
  ConversationTurnFromJSON,
  ConversationTurnToJSON,
  CurrencyCodeFromJSON,
  CurrencyCodeToJSON,
  FreightClaimPaymentSourceFromJSON,
  FreightClaimPaymentSourceToJSON,
  FreightClaimReadModelFromJSON,
  FreightClaimReadModelToJSON,
  FreightClaimStateFromJSON,
  FreightClaimStateToJSON,
} from "../models/index";

export interface CancelFreightClaimSnoozeRequest {
  claimId: string;
}

export interface DeleteFreightClaimRequest {
  claimId: string;
  reason: string;
  keepDocuments: boolean;
}

export interface GetById1Request {
  claimId: string;
}

export interface SetCarrierClaimNumberRequest {
  claimId: string;
  carrierClaimNumber?: string | null;
}

export interface SetCarrierConversationTurnRequest {
  claimId: string;
  turn?: ConversationTurn | null;
}

export interface SetCarrierFrontConversationIdRequest {
  claimId: string;
  frontConversationId?: string | null;
}

export interface SetCustomerConversationTurnRequest {
  claimId: string;
  turn?: ConversationTurn | null;
}

export interface SetCustomerFrontConversationIdRequest {
  claimId: string;
  frontConversationId?: string | null;
}

export interface SetFreightClaimAssigneeRequest {
  claimId: string;
  assignee: string;
}

export interface SetFreightClaimStateRequest {
  claimId: string;
  state: FreightClaimState;
  paymentAmount?: number | null;
  paymentCurrency?: CurrencyCode | null;
  paymentSource?: FreightClaimPaymentSource | null;
  paymentReason?: string | null;
  payoutAmount?: number | null;
  payoutCurrency?: CurrencyCode | null;
  insuranceAmount?: number | null;
  insuranceCurrency?: CurrencyCode | null;
}

export interface SetInsuranceConversationTurnRequest {
  claimId: string;
  turn?: ConversationTurn | null;
}

export interface SetInsuranceFrontConversationIdRequest {
  claimId: string;
  frontConversationId?: string | null;
}

export interface SnoozeFreightClaimRequest {
  claimId: string;
  snoozedUntil: string;
  reason?: string | null;
}

/**
 *
 */
export class FreightClaimsApi extends runtime.BaseAPI {
  /**
   */
  async cancelFreightClaimSnoozeRaw(
    requestParameters: CancelFreightClaimSnoozeRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["claimId"] == null) {
      throw new runtime.RequiredError(
        "claimId",
        'Required parameter "claimId" was null or undefined when calling cancelFreightClaimSnooze().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["claimId"] != null) {
      queryParameters["claimId"] = requestParameters["claimId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/freight-claims/cancel-freight-claim-snooze`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async cancelFreightClaimSnooze(
    requestParameters: CancelFreightClaimSnoozeRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.cancelFreightClaimSnoozeRaw(requestParameters, initOverrides);
  }

  /**
   */
  async deleteFreightClaimRaw(
    requestParameters: DeleteFreightClaimRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["claimId"] == null) {
      throw new runtime.RequiredError(
        "claimId",
        'Required parameter "claimId" was null or undefined when calling deleteFreightClaim().',
      );
    }

    if (requestParameters["reason"] == null) {
      throw new runtime.RequiredError(
        "reason",
        'Required parameter "reason" was null or undefined when calling deleteFreightClaim().',
      );
    }

    if (requestParameters["keepDocuments"] == null) {
      throw new runtime.RequiredError(
        "keepDocuments",
        'Required parameter "keepDocuments" was null or undefined when calling deleteFreightClaim().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["claimId"] != null) {
      queryParameters["claimId"] = requestParameters["claimId"];
    }

    if (requestParameters["reason"] != null) {
      queryParameters["reason"] = requestParameters["reason"];
    }

    if (requestParameters["keepDocuments"] != null) {
      queryParameters["keepDocuments"] = requestParameters["keepDocuments"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/freight-claims/delete-freight-claim`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async deleteFreightClaim(
    requestParameters: DeleteFreightClaimRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.deleteFreightClaimRaw(requestParameters, initOverrides);
  }

  /**
   */
  async getById1Raw(
    requestParameters: GetById1Request,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<FreightClaimReadModel>> {
    if (requestParameters["claimId"] == null) {
      throw new runtime.RequiredError(
        "claimId",
        'Required parameter "claimId" was null or undefined when calling getById1().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["claimId"] != null) {
      queryParameters["claimId"] = requestParameters["claimId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/freight-claims/get-by-id`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      FreightClaimReadModelFromJSON(jsonValue),
    );
  }

  /**
   */
  async getById1(
    requestParameters: GetById1Request,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<FreightClaimReadModel> {
    const response = await this.getById1Raw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async setCarrierClaimNumberRaw(
    requestParameters: SetCarrierClaimNumberRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["claimId"] == null) {
      throw new runtime.RequiredError(
        "claimId",
        'Required parameter "claimId" was null or undefined when calling setCarrierClaimNumber().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["claimId"] != null) {
      queryParameters["claimId"] = requestParameters["claimId"];
    }

    if (requestParameters["carrierClaimNumber"] != null) {
      queryParameters["carrierClaimNumber"] =
        requestParameters["carrierClaimNumber"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/freight-claims/set-carrier-claim-number`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async setCarrierClaimNumber(
    requestParameters: SetCarrierClaimNumberRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.setCarrierClaimNumberRaw(requestParameters, initOverrides);
  }

  /**
   */
  async setCarrierConversationTurnRaw(
    requestParameters: SetCarrierConversationTurnRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["claimId"] == null) {
      throw new runtime.RequiredError(
        "claimId",
        'Required parameter "claimId" was null or undefined when calling setCarrierConversationTurn().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["claimId"] != null) {
      queryParameters["claimId"] = requestParameters["claimId"];
    }

    if (requestParameters["turn"] != null) {
      queryParameters["turn"] = requestParameters["turn"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/freight-claims/set-carrier-conversation-turn`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async setCarrierConversationTurn(
    requestParameters: SetCarrierConversationTurnRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.setCarrierConversationTurnRaw(requestParameters, initOverrides);
  }

  /**
   */
  async setCarrierFrontConversationIdRaw(
    requestParameters: SetCarrierFrontConversationIdRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["claimId"] == null) {
      throw new runtime.RequiredError(
        "claimId",
        'Required parameter "claimId" was null or undefined when calling setCarrierFrontConversationId().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["claimId"] != null) {
      queryParameters["claimId"] = requestParameters["claimId"];
    }

    if (requestParameters["frontConversationId"] != null) {
      queryParameters["frontConversationId"] =
        requestParameters["frontConversationId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/freight-claims/set-carrier-front-conversation-id`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async setCarrierFrontConversationId(
    requestParameters: SetCarrierFrontConversationIdRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.setCarrierFrontConversationIdRaw(
      requestParameters,
      initOverrides,
    );
  }

  /**
   */
  async setCustomerConversationTurnRaw(
    requestParameters: SetCustomerConversationTurnRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["claimId"] == null) {
      throw new runtime.RequiredError(
        "claimId",
        'Required parameter "claimId" was null or undefined when calling setCustomerConversationTurn().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["claimId"] != null) {
      queryParameters["claimId"] = requestParameters["claimId"];
    }

    if (requestParameters["turn"] != null) {
      queryParameters["turn"] = requestParameters["turn"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/freight-claims/set-customer-conversation-turn`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async setCustomerConversationTurn(
    requestParameters: SetCustomerConversationTurnRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.setCustomerConversationTurnRaw(requestParameters, initOverrides);
  }

  /**
   */
  async setCustomerFrontConversationIdRaw(
    requestParameters: SetCustomerFrontConversationIdRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["claimId"] == null) {
      throw new runtime.RequiredError(
        "claimId",
        'Required parameter "claimId" was null or undefined when calling setCustomerFrontConversationId().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["claimId"] != null) {
      queryParameters["claimId"] = requestParameters["claimId"];
    }

    if (requestParameters["frontConversationId"] != null) {
      queryParameters["frontConversationId"] =
        requestParameters["frontConversationId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/freight-claims/set-customer-front-conversation-id`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async setCustomerFrontConversationId(
    requestParameters: SetCustomerFrontConversationIdRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.setCustomerFrontConversationIdRaw(
      requestParameters,
      initOverrides,
    );
  }

  /**
   */
  async setFreightClaimAssigneeRaw(
    requestParameters: SetFreightClaimAssigneeRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["claimId"] == null) {
      throw new runtime.RequiredError(
        "claimId",
        'Required parameter "claimId" was null or undefined when calling setFreightClaimAssignee().',
      );
    }

    if (requestParameters["assignee"] == null) {
      throw new runtime.RequiredError(
        "assignee",
        'Required parameter "assignee" was null or undefined when calling setFreightClaimAssignee().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["claimId"] != null) {
      queryParameters["claimId"] = requestParameters["claimId"];
    }

    if (requestParameters["assignee"] != null) {
      queryParameters["assignee"] = requestParameters["assignee"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/freight-claims/set-freight-claim-assignee`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async setFreightClaimAssignee(
    requestParameters: SetFreightClaimAssigneeRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.setFreightClaimAssigneeRaw(requestParameters, initOverrides);
  }

  /**
   */
  async setFreightClaimStateRaw(
    requestParameters: SetFreightClaimStateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["claimId"] == null) {
      throw new runtime.RequiredError(
        "claimId",
        'Required parameter "claimId" was null or undefined when calling setFreightClaimState().',
      );
    }

    if (requestParameters["state"] == null) {
      throw new runtime.RequiredError(
        "state",
        'Required parameter "state" was null or undefined when calling setFreightClaimState().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["claimId"] != null) {
      queryParameters["claimId"] = requestParameters["claimId"];
    }

    if (requestParameters["state"] != null) {
      queryParameters["state"] = requestParameters["state"];
    }

    if (requestParameters["paymentAmount"] != null) {
      queryParameters["paymentAmount"] = requestParameters["paymentAmount"];
    }

    if (requestParameters["paymentCurrency"] != null) {
      queryParameters["paymentCurrency"] = requestParameters["paymentCurrency"];
    }

    if (requestParameters["paymentSource"] != null) {
      queryParameters["paymentSource"] = requestParameters["paymentSource"];
    }

    if (requestParameters["paymentReason"] != null) {
      queryParameters["paymentReason"] = requestParameters["paymentReason"];
    }

    if (requestParameters["payoutAmount"] != null) {
      queryParameters["payoutAmount"] = requestParameters["payoutAmount"];
    }

    if (requestParameters["payoutCurrency"] != null) {
      queryParameters["payoutCurrency"] = requestParameters["payoutCurrency"];
    }

    if (requestParameters["insuranceAmount"] != null) {
      queryParameters["insuranceAmount"] = requestParameters["insuranceAmount"];
    }

    if (requestParameters["insuranceCurrency"] != null) {
      queryParameters["insuranceCurrency"] =
        requestParameters["insuranceCurrency"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/freight-claims/set-freight-claim-state`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async setFreightClaimState(
    requestParameters: SetFreightClaimStateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.setFreightClaimStateRaw(requestParameters, initOverrides);
  }

  /**
   */
  async setInsuranceConversationTurnRaw(
    requestParameters: SetInsuranceConversationTurnRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["claimId"] == null) {
      throw new runtime.RequiredError(
        "claimId",
        'Required parameter "claimId" was null or undefined when calling setInsuranceConversationTurn().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["claimId"] != null) {
      queryParameters["claimId"] = requestParameters["claimId"];
    }

    if (requestParameters["turn"] != null) {
      queryParameters["turn"] = requestParameters["turn"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/freight-claims/set-insurance-conversation-turn`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async setInsuranceConversationTurn(
    requestParameters: SetInsuranceConversationTurnRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.setInsuranceConversationTurnRaw(
      requestParameters,
      initOverrides,
    );
  }

  /**
   */
  async setInsuranceFrontConversationIdRaw(
    requestParameters: SetInsuranceFrontConversationIdRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["claimId"] == null) {
      throw new runtime.RequiredError(
        "claimId",
        'Required parameter "claimId" was null or undefined when calling setInsuranceFrontConversationId().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["claimId"] != null) {
      queryParameters["claimId"] = requestParameters["claimId"];
    }

    if (requestParameters["frontConversationId"] != null) {
      queryParameters["frontConversationId"] =
        requestParameters["frontConversationId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/freight-claims/set-insurance-front-conversation-id`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async setInsuranceFrontConversationId(
    requestParameters: SetInsuranceFrontConversationIdRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.setInsuranceFrontConversationIdRaw(
      requestParameters,
      initOverrides,
    );
  }

  /**
   */
  async snoozeFreightClaimRaw(
    requestParameters: SnoozeFreightClaimRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["claimId"] == null) {
      throw new runtime.RequiredError(
        "claimId",
        'Required parameter "claimId" was null or undefined when calling snoozeFreightClaim().',
      );
    }

    if (requestParameters["snoozedUntil"] == null) {
      throw new runtime.RequiredError(
        "snoozedUntil",
        'Required parameter "snoozedUntil" was null or undefined when calling snoozeFreightClaim().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["claimId"] != null) {
      queryParameters["claimId"] = requestParameters["claimId"];
    }

    if (requestParameters["snoozedUntil"] != null) {
      queryParameters["snoozedUntil"] = requestParameters["snoozedUntil"];
    }

    if (requestParameters["reason"] != null) {
      queryParameters["reason"] = requestParameters["reason"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/freight-claims/snooze-freight-claim`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async snoozeFreightClaim(
    requestParameters: SnoozeFreightClaimRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.snoozeFreightClaimRaw(requestParameters, initOverrides);
  }
}
